import { createApp } from 'vue'
import FormInputPhoneField from './FormInputPhoneField'

const el = '.kb-component--form-input-phone-field'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormInputPhoneFieldDOM) => {
            const props = {
                tooltipText: FormInputPhoneFieldDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputPhoneFieldDOM.dataset.errormessagelabel,
                helpMessageLabel:
                    FormInputPhoneFieldDOM.dataset.helpmessagelabel,
                placeholder: FormInputPhoneFieldDOM.dataset.placeholder,
                label: FormInputPhoneFieldDOM.dataset.label,
                isRequired: !!(
                    FormInputPhoneFieldDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputPhoneFieldDOM.dataset.fieldname
            }

            const component = createApp(FormInputPhoneField, props).use(Store)
            component.mount(FormInputPhoneFieldDOM)
        })
    }
}
